var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"py-0 overflow-y-auto",attrs:{"max-height":_vm.maxHeight,"three-line":""}},[_vm._l((_vm.reports),function(report,index){return [(index !== 0)?_c('v-divider',{key:index}):_vm._e(),_c('ReviewReportListItem',{key:report.title,attrs:{"report":report}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }